<div class="card-1">
  <div class="row">
    <div class="col-md-6 col-12 mb-3">
      <label>Select Date</label>
      <kendo-dropdownlist [data]="sectorQuarterDates" [formControl]="dateSelector"></kendo-dropdownlist>
    </div>
  </div>
  <div>
    <div class="loader" *ngIf="loadingData"></div>
    <div *ngIf="gridData && gridData.length > 0 && !loadingData" class="sector-grid-container">
      <div *ngFor="let grid of gridData | slice : 0 : 1">
        <div class="table-name">
          <b>{{ grid.gridName }}</b>
        </div>
        <div class="hr-scrolable-table stripe-table">
          <table mat-table [dataSource]="grid.gridData.dataSource" class="table" multiTemplateDataRows>
            <ng-container *ngFor="let col of grid.gridColumns" [matColumnDef]="col.field">
              <th mat-header-cell *matHeaderCellDef class="nowrap-header">
                {{ col.label }}
              </th>
              <td mat-cell *matCellDef="let element" [ngClass]="col.field === 'ticker' ? '' : 'text-end'">
                {{ element[col.field] }}
              </td>
              <td mat-footer-cell *matFooterCellDef>
                <div class="text-end" [hidden]="col.field !== 'roe'">
                  {{ grid.roeSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'ebitMargin'">
                  {{ grid.ebitMarginSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'evToSales'">
                  {{ grid.evToSalesSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'eveToEbit'">
                  {{ grid.eveToEbitSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'grossMargin'">
                  {{ grid.grossMarginSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'priceToBookValue'">
                  {{ grid.priceToBookValueSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'priceToEarnings'">
                  {{ grid.priceToEarningsSum }}
                </div>
                <div class="text-end" [hidden]="col.field !== 'priceToSales'">
                  {{ grid.priceToSalesSum }}
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="grid.displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: grid.displayedColumns"></tr>
            <tr mat-footer-row *matFooterRowDef="grid.displayedColumns; sticky: true"></tr>
          </table>
          <!-- <mat-paginator
            [length]="grid.gridData.total"
            [pageSize]="grid.gridData.pageSize"
            [pageIndex]="grid.gridData.pageIndex"
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator> -->
        </div>
      </div>
    </div>
  </div>
</div>
